import * as React from 'react'
import {FC} from 'react'
import Form from 'antd/lib/form'
import CalcCard from '../../../../common/components/calc-card'
import {FormInstance} from 'antd/lib/form'
import {Row, Col} from 'antd/lib/grid'
import 'antd/lib/grid/style'
import Radio from 'antd/lib/radio'
import 'antd/lib/radio/style'
import Input from 'antd/lib/input'
import 'antd/lib/input/style'
import InputNumber from 'antd/lib/input-number'
import 'antd/lib/input-number/style'
import Select from 'antd/lib/select'
import 'antd/lib/select/style'
import IDS from '../../constants/ids'
import {COMPONENT_SIZE} from '../../constants'
import {
    STANDARD_ITEM_RULES_SELECT,
    STANDARD_ITEM_RULES_POSITIVE_SUM,
} from '../../../../common/constants'
import LABELS from '../../constants/labels'
import {CargoTypes} from '../../types/models/cargo-types'
import {ProgramInfo} from '../../types/models/program-info'
import divideIntegerBySpace from '../../../../../common/helpers/divide-integer-by-space'

interface CargoInfoPropsInterface {
    form: FormInstance
    cargoTypes: CargoTypes
    programInfo: ProgramInfo
    onValueChange: (fieldName: string | string[]) => void
}

const {Item} = Form,
    {Option} = Select,
    {Group} = Radio

const CargoInfo: FC<CargoInfoPropsInterface> = ({cargoTypes, programInfo, onValueChange, form}) => {
    // Не даёт сделать запрос цены, если сумма указана неверно
    const handleChange = (eventOrValue, id) => {
        const currentInsSum = form.getFieldValue(IDS.INSURANCE_SUM)
        if (currentInsSum && parseInt(currentInsSum) > 0) {
            onValueChange(id)
        }
    }

    return (
        <CalcCard>
            <h2>Информация о грузе</h2>
            <Row gutter={{xs: 24, sm: 24, md: 24, xl: 24}}>
                <Col xs={24} sm={12} md={12}>
                    <Item
                        name={IDS.INSURANCE_SUM}
                        label={LABELS.INSURANCE_SUM}
                        rules={STANDARD_ITEM_RULES_POSITIVE_SUM}
                        required
                    >
                        <InputNumber
                            className='e-full-wide'
                            size={COMPONENT_SIZE}
                            type='tel'
                            step={100000}
                            placeholder='Укажите стоимость'
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
                            onChange={e => {
                                handleChange(e, IDS.INSURANCE_SUM)
                            }}
                        />
                    </Item>
                </Col>
                <Col xs={24} sm={12} md={12}>
                    <Item
                        name={IDS.CARGO_PACKAGING}
                        label={LABELS.CARGO_PACKAGING}
                        rules={STANDARD_ITEM_RULES_SELECT}
                        required
                    >
                        <Select
                            className='e-full-wide'
                            placeholder='Выберите упаковку груза'
                            size={COMPONENT_SIZE}
                            onChange={e => {
                                handleChange(e, IDS.CARGO_PACKAGING)
                            }}
                        >
                            {programInfo.packaging.map((packagingType, index) => (
                                <Option
                                    value={`${packagingType.code}#${index}`}
                                    key={`cargo-${index}-${packagingType.code}`}
                                >
                                    {packagingType.name}
                                </Option>
                            ))}
                        </Select>
                    </Item>
                </Col>
            </Row>
            <Row gutter={{xs: 24, sm: 24, md: 24, xl: 24}}>
                <Col xs={24} sm={24} md={24}>
                    <Item
                        name={IDS.CARGO_TYPE}
                        label={LABELS.CARGO_TYPE}
                        rules={STANDARD_ITEM_RULES_SELECT}
                        required
                    >
                        <Select
                            showSearch
                            className='e-full-wide'
                            placeholder='Выберите тип груза'
                            optionFilterProp='children'
                            size={COMPONENT_SIZE}
                            onChange={e => {
                                handleChange(e, IDS.CARGO_TYPE)
                            }}
                        >
                            {cargoTypes.map((cargoItem, index) => (
                                <Option value={cargoItem.id} key={`cargo-${cargoItem.id}`}>
                                    {cargoItem.name}
                                </Option>
                            ))}
                        </Select>
                    </Item>
                </Col>
            </Row>
            <Row gutter={{xs: 24, sm: 24, md: 24, xl: 24}}>
                <Col xs={24} sm={24} md={24}>
                    <Item
                        name={IDS.CARGO_LOADING_TYPE}
                        label={LABELS.CARGO_LOADING_TYPE}
                        rules={STANDARD_ITEM_RULES_SELECT}
                    >
                        <Group
                            className='e-full-wide'
                            onChange={e => {
                                handleChange(e, IDS.CARGO_LOADING_TYPE)
                            }}
                        >
                            {Object.keys(programInfo.loading).map((key, index) => (
                                <Radio value={key} key={`cargo-${key}`}>
                                    {key === 'dimension'
                                        ? 'Габаритный груз'
                                        : key === 'notDimension'
                                        ? 'Негабаритный груз'
                                        : key === 'container'
                                        ? 'Груз в контейнере'
                                        : 'Неизвестно'}
                                </Radio>
                            ))}
                        </Group>
                    </Item>
                </Col>
            </Row>
        </CalcCard>
    )
}

export default CargoInfo
